import type { QuestionnaireResponse } from "@medplum/fhirtypes";
import { QUESTIONNAIRE_RESPONSE_COLLECTION_NAME } from "../../fhir";
import { createSubscriptionHook } from "./create-subscription-hook";

export const useQuestionnaireInstanceSubscription = createSubscriptionHook<QuestionnaireResponse>(
  "QuestionnaireResponse",
  QUESTIONNAIRE_RESPONSE_COLLECTION_NAME,
);
